import { render, staticRenderFns } from "./CecUnmArticleDetail.vue?vue&type=template&id=def5ddae&scoped=true"
import script from "./CecUnmArticleDetail.vue?vue&type=script&lang=js"
export * from "./CecUnmArticleDetail.vue?vue&type=script&lang=js"
import style0 from "./CecUnmArticleDetail.vue?vue&type=style&index=0&id=def5ddae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def5ddae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('def5ddae')) {
      api.createRecord('def5ddae', component.options)
    } else {
      api.reload('def5ddae', component.options)
    }
    module.hot.accept("./CecUnmArticleDetail.vue?vue&type=template&id=def5ddae&scoped=true", function () {
      api.rerender('def5ddae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/unmarticle/CecUnmArticleDetail.vue"
export default component.exports